import { useAuth } from '@/hooks/useAuth';
import { useImpersonation } from '@/contexts/ImpersonationContext';

/**
 * Hook that returns the effective user for data fetching.
 * When an admin is impersonating a user, returns the impersonated user's ID.
 * Otherwise, returns the real authenticated user's ID.
 * 
 * This enables admins to view the app as any user for troubleshooting.
 */
export function useEffectiveUser() {
  const { user, loading: authLoading } = useAuth();
  const { isImpersonating, impersonatedUser } = useImpersonation();

  // Return impersonated user if active, otherwise real user
  const effectiveUserId = isImpersonating && impersonatedUser 
    ? impersonatedUser.id 
    : user?.id;

  const effectiveUser = isImpersonating && impersonatedUser
    ? { id: impersonatedUser.id, email: impersonatedUser.email }
    : user;

  return {
    effectiveUserId,
    effectiveUser,
    isImpersonating,
    realUser: user,
    authLoading,
  };
}
